export { default as PersonalDiscount } from './PersonalDiscount/PersonalDiscount';
